import { formatAudiencesToBE } from '../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/formatters'
import { createNameForFacebookLineItem } from '../../../../Multiplatform/LineItemForms/formatters'
import {
  formatEndDate,
  formatStartDate
} from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/formatters'
import { formatShowTargetToBE } from '../../../formatters/geolocationsFormatters'
import { formatBehaviorsToBE, formatInterestsToBE } from '../../../formatters'
import { transformPlacementsToBE as transformCustomPlacementsToBE } from '../../../placements/helpers'
import { formatPlacementsOptionsToBE, getPayloadForEngagementObjective } from './helpers'
import { formatGeoTargetingToBE } from '../../../LineItemForms/LineItemFacebookEdit/formatters'

import {
  AUDIENCES_OPTION,
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { OPTION_YES } from '../../../../../constants/forms'
import {
  AD_RECALL_LIFT,
  OUTCOME_APP_PROMOTION,
  OUTCOME_AWARENESS,
  OUTCOME_ENGAGEMENT,
  OUTCOME_LEADS,
  OUTCOME_SALES,
  OUTCOME_TRAFFIC,
  REACH
} from '../../../../../constants/campaigns'
import { CUSTOM_EVENT_TYPE, PROMOTED_PIXEL } from '../../../../../constants/selectLists/customEventTypes/fields'
import { END_DATE, START_DATE } from '../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS
} from '../../../../Multiplatform/Partnerships/RightForms/fields'
import { BUDGET_LIFETIME, IMPRESSIONS } from '../../../../Multiplatform/UploadAdCreative/fields'
import {
  AGE,
  PLACEMENT_POSITIONS,
  recentLocationTypes,
  TARGET_COST_CAP,
  targetingRelaxationTypes
} from '../../../../Multiplatform/LineItemForms/fields'
import {
  GEO_EXCLUSIONS,
  SHOW_COUNTRIES,
  SHOW_OPTION,
  SHOW_REGIONS
} from '../../../../ReusableFormFields/GeolocationsFields/fields'
import { AGE_MAX, AGE_MIN, FEMALE, GENDER, MALE } from '../../../fields'
import { INTERESTS } from '../../../../ReusableFormFields/InterestsFields/fields'
import {
  ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS,
  CONVERSION_EVENT_TYPE_RADIO_BUTTON,
  CUSTOM,
  CUSTOM_CONVERSION_EVENT,
  CUSTOM_CONVERSION_ID,
  LEADS_ON_META_LEAD_ADS_FORM,
  LINE_ITEM_OBJECTIVE,
  NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL,
  OBJECT_STORE_URL,
  PLACEMENTS_OPTION,
  STANDARD_DATASET_EVENT,
  USER_OS
} from './fields'
import { DESTINATION_TYPE } from '../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { BEHAVIORS } from '../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields/AdvancedAudienceTargetingSection/BehavioursSelect/fields'
import { FB_PAGE_CHOICE } from '../../../AdForms/fields'
import { standardEvents } from '../../../../../constants/selectLists/customEventTypes'
import { APPLICATION_ID } from '../reusableFields/AppListField/fields'

import { getObjectStoreUrl } from '../helpers'
import { mobilePlatformsEnums } from '../reusableFields/fields'

export const formatPlacementsToBE = (values, campaignObjective) => {
  if (values[PLACEMENTS_OPTION] === CUSTOM) {
    return transformCustomPlacementsToBE(values[PLACEMENT_POSITIONS], campaignObjective)
  } else {
    return {
      [PLACEMENT_POSITIONS]: formatPlacementsOptionsToBE(values)
    }
  }
}

export const transformValuesToBE = ({
  values,
  adAccountId,
  right,
  campaign,
  // selectedCampaignObjective may be different from actual campaignObjective,
  // because on campaign form if user select REACH - we send OUTCOME_AWARENESS
  selectedCampaignObjective,
  campaignObjective,
  showTargetCostCapField,
  showPromotedObjectStepForAppPromotionCampaign,
  facebookClientApps
}) => {
  const { allocation_type: rightAllocationType, bid_cap: rightBidCap } = right

  const lineItemName = createNameForFacebookLineItem({
    startDate: values[START_DATE],
    geotargetingOption: values[SHOW_OPTION],
    countries: values[SHOW_COUNTRIES],
    regions: values[SHOW_REGIONS],
    customAudiences: values[CUSTOM_AUDIENCES]
  })

  const reusablePayload = {
    account: adAccountId,
    name: lineItemName,
    status: 'active',
    campaign_id: campaign.id,
    campaign_objective: campaign.objective,
    time_start: formatStartDate(values[START_DATE]),
    time_stop: formatEndDate(values[END_DATE]),
    bidding_type: 'automatic',

    ...(!campaign['budget_lifetime'] &&
      rightAllocationType === DIGITAL_ALLOCATION_TYPE_BUDGET && { [BUDGET_LIFETIME]: values[BUDGET_LIFETIME] }),
    ...(!campaign['budget_lifetime'] &&
      rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS && {
        [BUDGET_LIFETIME]: (values[IMPRESSIONS] / 1000) * rightBidCap,
        bidding_type: 'manual',
        [TARGET_COST_CAP]: rightBidCap
      }),
    ...(showTargetCostCapField && {
      [TARGET_COST_CAP]: values[TARGET_COST_CAP]
    }),
    languages: [1001],
    geo_targeting: {
      ...recentLocationTypes,
      ...formatShowTargetToBE({
        geotargetingOption: values[SHOW_OPTION],
        countries: values[SHOW_COUNTRIES],
        regions: values[SHOW_REGIONS]
      })
    },
    ...(values[GEO_EXCLUSIONS].length && {
      [GEO_EXCLUSIONS]: formatGeoTargetingToBE(values[GEO_EXCLUSIONS])
    }),
    [AGE]: {
      [AGE_MIN]: values[AGE_MIN],
      [AGE_MAX]: values[AGE_MAX]
    },
    [GENDER]: {
      [MALE]: values[MALE],
      [FEMALE]: values[FEMALE]
    },
    // placements
    ...formatPlacementsToBE(values, campaignObjective),
    ...(values[INTERESTS].length && { [INTERESTS]: formatInterestsToBE(values[INTERESTS]) }),
    ...(values[BEHAVIORS].length && { [BEHAVIORS]: formatBehaviorsToBE(values[BEHAVIORS]) }),
    ...(values[AUDIENCES_OPTION] === OPTION_YES && {
      [CUSTOM_AUDIENCES]: formatAudiencesToBE(values[CUSTOM_AUDIENCES])
    }),
    ...(values[CUSTOM_AUDIENCES_EXCLUSION].length && {
      [CUSTOM_AUDIENCES_EXCLUSION]: formatAudiencesToBE(values[CUSTOM_AUDIENCES_EXCLUSION])
    }),
    billing_event: 'impressions',
    pacing: ['standard'],
    brand_safety_content_filter_levels: ['facebook_strict', 'an_strict'],
    excluded_publisher_categories: [
      'dating',
      'gambling',
      'debated_social_issues',
      'mature_audiences',
      'tragedy_and_conflict'
    ],
    ...targetingRelaxationTypes
  }

  return getDataByCampaignObjective({
    selectedCampaignObjective,
    values,
    campaign,
    reusablePayload,
    showPromotedObjectStepForAppPromotionCampaign,
    facebookClientApps
  })
}

const formatEventSourcePromotedObject = values => {
  if (values[CONVERSION_EVENT_TYPE_RADIO_BUTTON] === CUSTOM_CONVERSION_EVENT) {
    return {
      [CUSTOM_CONVERSION_ID]: values[CUSTOM_CONVERSION_ID]
    }
  } else {
    const isStandardEvent = standardEvents.includes(values[CUSTOM_EVENT_TYPE])

    const eventPayload = isStandardEvent
      ? { custom_event_type: values[CUSTOM_EVENT_TYPE] }
      : {
          custom_event_str: values[CUSTOM_EVENT_TYPE],
          custom_event_type: 'OTHER'
        }

    return {
      ...(values[PROMOTED_PIXEL] && { pixel_id: values[PROMOTED_PIXEL] }),
      ...eventPayload
    }
  }
}

const getDataByCampaignObjective = ({
  selectedCampaignObjective,
  values,
  campaign,
  reusablePayload,
  showPromotedObjectStepForAppPromotionCampaign,
  facebookClientApps
}) => {
  // On campaign form if user select REACH - we send OUTCOME_AWARENESS, so we have separate state to distinguish what was originally selected.
  // If user select existing campaign - the only way we can find out what goal was originally selected is to check campaign name. (check if it includes 'reach')
  if (selectedCampaignObjective === REACH || campaign?.name?.toLowerCase().includes('reach')) {
    return {
      ...reusablePayload,
      frequency: { impressions: 2, event: 'impressions', days: 7 },
      objective: REACH
    }
  } else if (selectedCampaignObjective === OUTCOME_AWARENESS) {
    return {
      ...reusablePayload,
      objective: AD_RECALL_LIFT
    }
  } else if (selectedCampaignObjective === OUTCOME_SALES) {
    return {
      ...reusablePayload,
      promoted_object: formatEventSourcePromotedObject(values),
      objective: 'offsite_conversions'
    }
  } else if (selectedCampaignObjective === OUTCOME_APP_PROMOTION) {
    const reusableAppPromotionPayload = {
      ...reusablePayload,
      [DESTINATION_TYPE]: 'app',
      objective: values[LINE_ITEM_OBJECTIVE],
      [USER_OS]: [values[USER_OS]],
      device_platforms: ['mobile']
    }
    if (showPromotedObjectStepForAppPromotionCampaign) {
      return {
        ...reusableAppPromotionPayload,
        promoted_object: {
          [APPLICATION_ID]: values[APPLICATION_ID],
          [OBJECT_STORE_URL]: getObjectStoreUrl({
            facebookClientApps,
            applicationId: values[APPLICATION_ID],
            platform: values[USER_OS]
          })
        }
      }
    } else {
      return {
        ...reusablePayload,
        // For iOS14+ campaigns we don't show promoted object step, and don't include it in payload,
        [USER_OS]: [mobilePlatformsEnums.iOS]
      }
    }
  } else if (selectedCampaignObjective === OUTCOME_LEADS) {
    if (values[CONVERSION_EVENT_TYPE_RADIO_BUTTON] === STANDARD_DATASET_EVENT) {
      return {
        ...reusablePayload,
        promoted_object: formatEventSourcePromotedObject(values),
        objective: 'offsite_conversions'
      }
    } else if (values[CONVERSION_EVENT_TYPE_RADIO_BUTTON] === LEADS_ON_META_LEAD_ADS_FORM) {
      return {
        ...reusablePayload,
        promoted_object: {
          page_id: values[FB_PAGE_CHOICE]
        },
        objective: 'lead_generation',
        [DESTINATION_TYPE]: 'on_ad'
      }
    }

    return {
      ...reusablePayload,
      promoted_object: formatEventSourcePromotedObject(values),
      objective: 'offsite_conversions'
    }
  } else if (selectedCampaignObjective === OUTCOME_ENGAGEMENT) {
    return getPayloadForEngagementObjective({ values, reusablePayload })
  } else if (selectedCampaignObjective === OUTCOME_TRAFFIC) {
    if (values[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS] === NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL) {
      // If selectedCampaignObjective is traffic, and the user says NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL then:
      // - set "objective": "link_clicks"
      return {
        ...reusablePayload,
        objective: 'link_clicks'
      }
    } else {
      // If selectedCampaignObjective is traffic, and the user says YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL then:
      // - set "objective": "landing_page_views"
      return {
        ...reusablePayload,
        objective: 'landing_page_views'
      }
    }
  } else {
    return reusablePayload
  }
}
